/**
 * BottomNavigation 아이콘 컴포넌트
 */
import svgPaths from "@/imports/svg-qlijbkvci6";

interface IconProps {
  active: boolean;
}

/**
 * 홈 아이콘
 */
export function HomeIcon({ active }: IconProps) {
  return (
    <div className={`h-[22px] relative shrink-0 w-[21.904px] ${active ? 'text-primary' : 'text-muted-foreground'}`}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 22 22">
        <g>
          <path d={svgPaths.p16de8700} fill="currentColor" />
        </g>
      </svg>
    </div>
  );
}

/**
 * 주문 아이콘
 */
export function OrdersIcon({ active }: IconProps) {
  return (
    <div className={`h-[22px] relative w-[18.34px] ${active ? 'text-primary' : 'text-muted-foreground'}`}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 19 22">
        <g clipPath="url(#clip0_6_3504)">
          <path d={svgPaths.p14b00320} fill="currentColor" />
          <path d="M3.60446 13.3636H14.7084" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.02583" />
          <path d="M3.60446 9.57909H14.7084" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.02583" />
          <path d="M3.60446 5.7114H14.7084" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.02583" />
        </g>
        <defs>
          <clipPath id="clip0_6_3504">
            <rect fill="white" height="22" width="18.3403" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

/**
 * QR 코드 아이콘
 */
export function QrCodeIcon({ active }: IconProps) {
  return (
    <div className={`relative shrink-0 size-[22px] ${active ? 'text-primary' : 'text-muted-foreground'}`}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 22 22">
        <g>
          <path d={svgPaths.p3e5bd700} fill="currentColor" />
          <path d={svgPaths.p360a600} fill="currentColor" />
          <path d={svgPaths.pf3bad00} fill="currentColor" />
          <path d={svgPaths.p304a7c40} fill="currentColor" />
          <path d={svgPaths.p1bb4da00} fill="currentColor" />
          <path d={svgPaths.p1451180} fill="currentColor" />
          <g>
            <path d={svgPaths.p3b319e00} fill="currentColor" />
            <path d={svgPaths.p2a7fbd80} fill="currentColor" />
            <path d={svgPaths.pe4c3840} fill="currentColor" />
            <path d={svgPaths.p3155f000} fill="currentColor" />
            <path d={svgPaths.pfb76380} fill="currentColor" />
          </g>
        </g>
      </svg>
    </div>
  );
}

/**
 * 포인트/세일 아이콘
 */
export function SaleIcon({ active }: IconProps) {
  return (
    <div className={`relative shrink-0 size-[22px] ${active ? 'text-primary' : 'text-muted-foreground'}`}>
      <div className="absolute inset-[-2.474%]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
          <g>
            <path d={svgPaths.p2fbb0100} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.08877" />
            <path d={svgPaths.p230e0580} stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.08877" />
            <g>
              <mask fill="white" id="path-3-inside-1_6_3480">
                <path d={svgPaths.p34264900} />
              </mask>
              <path d={svgPaths.p34264900} fill="black" />
              <path d={svgPaths.p2045e900} fill="currentColor" mask="url(#path-3-inside-1_6_3480)" />
            </g>
            <g>
              <mask fill="white" id="path-5-inside-2_6_3480">
                <path d={svgPaths.p3eacabc0} />
              </mask>
              <path d={svgPaths.p3eacabc0} fill="black" />
              <path d={svgPaths.p2d8ebf80} fill="currentColor" mask="url(#path-5-inside-2_6_3480)" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}

/**
 * 설정 아이콘
 */
export function SettingsIcon({ active }: IconProps) {
  return (
    <div className={`h-[22px] relative shrink-0 w-[22.027px] ${active ? 'text-primary' : 'text-muted-foreground'}`}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 23 22">
        <g>
          <path d={svgPaths.p375c3540} fill="currentColor" />
          <path d={svgPaths.p1156e500} fill="currentColor" />
        </g>
      </svg>
    </div>
  );
}
